import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommentDiscussion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.75 1C0.783501 1 0 1.7835 0 2.75V12.25C0 13.2165 0.783502 14 1.75 14H3V15.5429C3 16.3476 3.65237 17 4.45711 17C4.84355 17 5.21418 16.8465 5.48744 16.5732L8.06066 14H14.25C15.2165 14 16 13.2165 16 12.25V2.75C16 1.7835 15.2165 1 14.25 1H1.75ZM1.5 2.75C1.5 2.61193 1.61193 2.5 1.75 2.5H14.25C14.3881 2.5 14.5 2.61193 14.5 2.75V12.25C14.5 12.3881 14.3881 12.5 14.25 12.5H7.75C7.55109 12.5 7.36032 12.579 7.21967 12.7197L4.5 15.4393V13.25C4.5 12.8358 4.16421 12.5 3.75 12.5H1.75C1.61193 12.5 1.5 12.3881 1.5 12.25V2.75Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.5 8.75C22.5 8.61193 22.3881 8.5 22.25 8.5H18.75C18.3358 8.5 18 8.16421 18 7.75C18 7.33579 18.3358 7 18.75 7H22.25C23.2165 7 24 7.7835 24 8.75V18.25C24 19.2165 23.2165 20 22.25 20H21V21.5429C21 22.3476 20.3476 23 19.5429 23C19.1564 23 18.7858 22.8465 18.5126 22.5732L15.9393 20H10.75C9.7835 20 9 19.2165 9 18.25V16.7855C9 16.3713 9.33579 16.0355 9.75 16.0355C10.1642 16.0355 10.5 16.3713 10.5 16.7855V18.25C10.5 18.3881 10.6119 18.5 10.75 18.5H16.25C16.4489 18.5 16.6397 18.579 16.7803 18.7197L19.5 21.4393V19.25C19.5 18.8358 19.8358 18.5 20.25 18.5H22.25C22.3881 18.5 22.5 18.3881 22.5 18.25V8.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgCommentDiscussion;
